// components/CustomTooltip.js
import React from 'react';
import { Tooltip } from '@mui/material';

const CustomTooltip = ({
  title,
  children,
  placement = 'top',
  arrow = true,
  enterDelay = 200,
  leaveDelay = 100,
  ...props
}) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow={arrow}
      enterDelay={enterDelay}
      leaveDelay={leaveDelay}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
